import React from 'react'
import styles from './styles.module.scss'

interface NoMarkProps {
    // Width and height in px
    size: number
    className?: string
}

// A silver cross for a "no" outcome, in the same metal as the Orb: light at the
// top left, darker toward the bottom right, with a soft pale glow
const NoMark: React.FC<NoMarkProps> = ({ size, className }) => (
    <svg
        className={`${styles.noMark} ${className || ''}`}
        width={size}
        height={size}
        viewBox="0 0 88 88"
        fill="none"
        aria-hidden="true"
    >
        <defs>
            <linearGradient id="noMarkSilver" x1="14" y1="14" x2="74" y2="74" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#eef0f3" />
                <stop offset="0.45" stopColor="#9ea3aa" />
                <stop offset="1" stopColor="#4a4e55" />
            </linearGradient>
            <linearGradient id="noMarkSheen" x1="14" y1="14" x2="44" y2="44" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#ffffff" stopOpacity="0.7" />
                <stop offset="1" stopColor="#ffffff" stopOpacity="0" />
            </linearGradient>
        </defs>
        <g strokeLinecap="round">
            <path d="M22 22L66 66M66 22L22 66" stroke="url(#noMarkSilver)" strokeWidth="14" />
            {/* Thin highlight along the top edge of each bar */}
            <path d="M22 18L62 58M62 18L18 62" stroke="url(#noMarkSheen)" strokeWidth="3" opacity="0.6" />
        </g>
    </svg>
)

export default NoMark
